import {
	Button,
	Tooltip, Dialog, DialogActions, DialogContent, DialogTitle
} from '@material-ui/core';

import Form from "@rjsf/material-ui";
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useActions, useValues } from 'kea';

import { formSchema, uiSchema } from '../components/schema';
import alertlogic from 'src/store/alert';


const EditAlertDialog = ({ alert }) => {

	const [open, setOpen] = useState(false);
	const { update } = useActions(alertlogic);

	const formData = {
		name: alert.name,
		type: alert.condition.monitor,
		value: alert.condition.value,
		value2: alert.condition?.value2
	};

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
	}

	const onSubmit = async (value) => {
		let changed_alert = {
			...alert,
			name: value.formData.name,
			condition: {
				monitor: value.formData.type,
				condition: '>',
				value: value.formData.value
			},
		}
		if (value.formData.value2) {
			changed_alert.condition.value2 = value.formData.value2;
		}
		update(changed_alert);
		setOpen(false);
	}

	const validate = (formData, errors) => {
		if (['offline', 'speed', 'service'].includes(formData.type) && formData.value < 1) {
			errors.value.addError('Please enter value greater than 0.');
		}
		// if (formData.type === 'offline' && formData.value < 1) {
		// 	errors.value.addError('Please enter value greater than 0.');
		// }
		// if (formData.type === 'speed' && formData.value < 1) {
		// 	errors.value.addError('Please enter value greater than 0.');
		// }
		// if (formData.type === 'service' && formData.value < 1) {
		// 	errors.value.addError('Please enter value greater than 0.');
		// }
		return errors;
	}
	return (
		<div>
			<Tooltip title="Edit selected alert">
				<Button
					color="default"
					variant="contained"
					aria-label="update"
					onClick={handleClickOpen}
					size='large'
				>
					Edit
				</Button>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth='md'
			>
				<DialogTitle id="form-dialog-title">
					Edit an Alert
				</DialogTitle>
				<DialogContent>
					<Form
						schema={formSchema}
						onSubmit={onSubmit}
						uiSchema={uiSchema}
						formData={formData}
						validate={validate}
						// liveValidate
						showErrorList={false}
					>
						<div style={{ textAlign: 'center', paddingTop: '15px' }}>
							<Button type={'submit'} variant="contained" color="primary">
								Save
							</Button>
						</div>
					</Form>
				</DialogContent>
				<DialogActions>
				</DialogActions>
			</Dialog>
		</div>
	)
}


export default EditAlertDialog
